var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484,
    height: 416,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCF9F5",
    d: "M12 260h165v155H12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.814 131.005C78.563 108.647 141.167 100.358 166 98l-51.748 191.643c-53.771 45.142-76.335 45.426-80.895 39.925-57.102-79.212-28.155-165.38-6.543-198.563Z",
    fill: "#FCF9F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M483.108 70.414c0-28.721-24.231-51.975-54.13-51.975s-54.129 23.281-54.129 51.975c0 17.426 8.925 32.836 22.615 42.28 5.804 4.005 9.337 10.605 9.337 17.703v3.976c0 8.644 6.954 15.659 15.523 15.659h13.307c8.57 0 15.525-7.015 15.525-15.659v-3.976c0-7.098 3.531-13.698 9.336-17.703 13.69-9.444 22.616-24.854 22.616-42.28Z",
    fill: "#F5F7FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M428.975 179.61c6.639 0 12.021-2.869 12.021-6.407 0-3.539-5.382-6.407-12.021-6.407-6.637 0-12.019 2.868-12.019 6.407 0 3.538 5.382 6.407 12.019 6.407Z",
    fill: "url(#a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M413.016 161.741v6.545c0 2.209 1.259 4.253 3.231 5.192 2.765 1.326 7.337 2.789 13.991 2.596 5.393-.138 8.925-1.022 11.143-1.961 2.163-.911 3.532-3.065 3.532-5.413v-3.617l-31.897-3.342Z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M413.016 167.486c.492.469 1.04.884 1.67 1.188 3.093 1.491 23.299 4.805 28.201 2.954.629-.248 1.204-.552 1.697-.938a5.783 5.783 0 0 0 .329-1.961v-3.618l-31.897-3.342v5.745-.028Z",
    fill: "url(#c)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M414.437 157.295c-1.807-.194-3.368 1.242-3.368 3.065v.193c0 2.486 1.397 4.75 3.615 5.827 3.094 1.492 23.3 4.806 28.201 2.955 2.464-.939 3.97-3.065 3.97-5.716v-.138c0-1.574-1.178-2.9-2.738-3.066l-29.707-3.12h.027Z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "m444.145 160.416-29.708-3.121a3.052 3.052 0 0 0-2.847 1.353c.602 1.409 1.67 2.596 3.121 3.287 3.094 1.491 24.177 5.247 28.201 3.314 1.561-.746 2.793-1.989 3.45-3.535-.493-.718-1.286-1.243-2.19-1.326l-.027.028Z",
    fill: "url(#e)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M413.287 146.69c-1.204 0-2.19.994-2.19 2.21v5.136c0 2.486 1.397 4.75 3.614 5.827 3.094 1.492 24.177 5.247 28.201 3.314 2.383-1.132 3.971-3.424 3.971-6.075V148.9c0-1.216-.987-2.21-2.191-2.21h-31.405Z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M428.976 152.435c9.632 0 17.44-1.867 17.44-4.17s-7.808-4.17-17.44-4.17c-9.633 0-17.441 1.867-17.441 4.17s7.808 4.17 17.441 4.17Z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M483.108 70.414c0-28.721-24.231-51.975-54.13-51.975s-54.129 23.281-54.129 51.975c0 17.426 8.925 32.836 22.615 42.28 5.804 4.005 9.337 10.605 9.337 17.703v3.976c0 8.644 6.954 15.659 15.523 15.659h13.307c8.57 0 15.525-7.015 15.525-15.659v-3.976c0-7.098 3.531-13.698 9.336-17.703 13.69-9.444 22.616-24.854 22.616-42.28Z",
    fill: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.976 148.043c7.047 0 12.76-1.36 12.76-3.038 0-1.677-5.713-3.037-12.76-3.037-7.046 0-12.758 1.36-12.758 3.037 0 1.678 5.712 3.038 12.758 3.038Z",
    fill: "#F5F7FA",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M425.637 146.856a.764.764 0 0 1-.74-.662l-9.39-73.709a.743.743 0 0 1 .629-.828.739.739 0 0 1 .821.635L426.349 146a.745.745 0 0 1-.63.829h-.082v.027Z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M431.496 146.856h-.083a.724.724 0 0 1-.63-.829l9.391-73.708a.722.722 0 0 1 .822-.635.724.724 0 0 1 .63.828l-9.391 73.709c-.055.386-.357.662-.739.662v-.027Z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M439.135 72.457a.767.767 0 0 1-.63-.331l-2.601-3.977s-.054-.055-.11-.055c-.054 0-.081.055-.109.055l-1.725 2.9c-.274.47-.794.773-1.341.8-.548 0-1.068-.248-1.369-.718l-2.355-3.562s-.055-.055-.109-.055c-.055 0-.082 0-.11.055l-2.054 3.01a1.58 1.58 0 0 1-1.313.69 1.583 1.583 0 0 1-1.315-.69l-2.984-4.308s-.055-.055-.109-.055c-.056 0-.083 0-.11.055l-2.711 4.722c-.192.36-.657.47-1.013.277-.356-.194-.465-.663-.273-1.022l2.709-4.723a1.62 1.62 0 0 1 1.315-.8 1.577 1.577 0 0 1 1.369.69l2.984 4.308s.055.055.11.055c0 0 .082 0 .109-.055l2.054-3.01c.301-.442.795-.69 1.314-.69.52 0 1.013.276 1.315.718l2.354 3.562s.055.083.109.055c.055 0 .083-.055.11-.055l1.725-2.9c.273-.47.794-.773 1.342-.8.547 0 1.068.248 1.369.718l2.6 3.976a.73.73 0 0 1-.219 1.022.763.763 0 0 1-.41.11l.082.028Z",
    fill: "url(#k)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M429.964 111.424c1.15-20.022 34.635-24.717 34.498-42.613-.082-11.019-13.388-19.193-16.236-20.85-20.946-12.068-46.71 1.878-52.021-8.009-1.315-2.458-.712-5.136-.357-6.655.549-2.293 1.753-4.447 3.533-6.407-14.786 9.279-24.532 25.296-24.532 43.523 0 18.227 8.925 32.836 22.615 42.281 5.804 4.004 9.337 10.605 9.337 17.702v3.977c0 8.644 6.954 15.658 15.523 15.658h13.307c8.57 0 15.525-7.014 15.525-15.658v-3.176c-1.835 1.408-3.943 2.403-6.243 2.375-7.995-.055-15.525-12.179-14.949-22.148Z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.854 117.776c25.721 0 46.573-20.29 46.573-45.319 0-25.028-20.852-45.318-46.573-45.318-25.722 0-46.573 20.29-46.573 45.318 0 25.03 20.851 45.319 46.573 45.319Z",
    fill: "#F5F7FA",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.44
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192.303 59.49C209.316 45.888 214.035 9.12 204.596.91c-2.744-2.33-5.268-1.226-43.683 15.931-19.098 8.58-28.427 13.114-31.611 22.55-1.865 5.76-1.536 13.482.549 19.61 1.098 3.186 3.183 7.108 7.793 14.584 4.171 6.618 3.842 6.373 5.159 8.334 3.073 4.657 8.891 12.378 19.646 21.447.549-3.432 1.537-7.599 3.074-12.133.658-1.716 3.073-8.702 6.914-14.462 6.695-9.927 14.269-12.868 19.866-17.28Z",
    fill: "url(#m)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m241.205 129.574-33.635-5.211-20.123 11.241-33.899-10.395s-29.921 3.71-30.565 3.492l31.998 278.152c8.599 4.392 19.626 7.721 33.577 8.239 12.753.464 24.306-.3 34.338-1.637 9.564-20.626 37.73-84.223 53.349-150.193 19.012-80.322-35.04-133.715-35.04-133.715v.027Z",
    fill: "url(#n)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.148 152.029S32.49 158.331 25.47 213.77c-7.02 55.467 12.928 81.386 21.439 99.475s48.64-22.945 65.896-38.66c17.228-15.715-38.93-123.593-66.657-122.556Z",
    fill: "url(#o)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M270.454 147.69c0-.846 8.774-14.406 8.774-14.406s23.751 10.04 44.868 58.468c21.088 48.427 23.574 95.491 15.559 110.333-8.013 14.869-61.011-14.597-71.511-35.223-10.501-20.626 2.31-119.172 2.31-119.172Z",
    fill: "url(#p)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M304.293 228.557c-7.311-30.011-25.065-95.3-25.065-95.3l-62.27-7.584s51.974 74.783 46.096 137.589c-5.002 53.502-36.649 129.54-45.92 150.875 7.487-.791 14.273-1.91 20.21-3.192 10.998-25.701 73.677-154.668 66.92-182.388h.029Z",
    fill: "url(#q)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.526 75.39s-4.505 43.462-5.879 50.719l37.672 13.56 19.099-11.841-10.939-46.709-39.953-5.73Z",
    fill: "url(#r)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M195.926 39.736c6.957 2.257 4.709 28.348 4.358 33.013-.224 2.973 1.834 8.307 3.355 11.785.866 1.979 0 3.094 0 3.094s0 .55-1.519 1.807c-5.259 2.513-16.04 7.094-22.574 5.932-8.89-1.583-22.608-19.262-25.094-26.029-2.458-6.766 8.639-19.258 8.639-19.258s6.505-6.461 16.262-9.69c9.757-3.23 16.544-.654 16.544-.654h.029Z",
    fill: "url(#s)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M158.38 72.522s-5.479-8.261-9.457-4.644c-3.978 3.617 8.88 14.917 16.049 15.52l-6.592-10.876Z",
    fill: "url(#t)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M267.53 198.575s5.205-23.682 5.294-24.528c.058-.682-29.454-33.858-42.616-47.882l-17.314-3.356s54.226 77.676 48.347 140.481c-3.627 38.606-19.246 88.916-32.202 121.956 54.518-103.676 61.275-166.809 61.275-166.809L267.5 198.602l.03-.027Z",
    fill: "url(#u)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m192.682 127.556 16.905 22.29 7.371-24.145-8.57-8.977-15.706 10.832ZM151.003 118.169l-5.382 7.994 25.066 24.964 10.529-22.427-30.213-10.531Z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M145.621 126.163C95.577 128.591 46.147 152 46.147 152c42.001 37.023 77.509 180.833 90.934 241.401 5.85 6.275 14.916 13.369 28.224 17.707 15.443-116.335-19.655-284.945-19.655-284.945h-.029Z",
    fill: "url(#v)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M167.734 385.244s21.234-201.404-22.112-259.054l-17.549 46.518 22.199 25.892-16.028 25.018s37.292 63.133 33.49 161.653v-.027Z",
    fill: "url(#w)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M173.817 162.341s3.656-16.615 11.378-20.762c7.722-4.147 24.685-4.911 24.685-4.911s-6.23 11.459-11.64 12.605c-5.412 1.173-16.409 6.82-16.935 12.195-.526 5.375-7.488 3.438-7.488.873Z",
    fill: "url(#x)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M409.274 211.316s17.69 6.18 27.969 3.136c10.279-3.044 15.654-11.093 14.68-12.155-.973-1.063-6.094-7.511-12.191-4.351-6.098 3.161-15.929 4.904-19.944 4.784-4.037-.138-12.618 1.929-12.618 1.929l2.104 6.657Z",
    fill: "url(#y)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m417.763 211.77-13.076-9.399a1376.812 1376.812 0 0 0-33.789 23.278c-34.334 24.45-48.626 37.068-55.381 54.129-1.891 4.786-5.772 14.983-.477 21.458.788.946 3.276 3.71 10.096 5.187 14.795 3.181 28.639-4.296 33.283-6.796 19.366-10.448 42.091-42.52 59.346-87.884l-.002.027Z",
    fill: "url(#z)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M46.206 309.861c-.41-.928-22.2-46.191-4.212-66.435 17.958-20.217 98.889-51.565 130.038-81.958 0 0 8.219 1.336 10.12 6.029 0 0-54.958 128.777-123.925 149.566 0 0-7.634 2.347-12.021-7.202Z",
    fill: "url(#A)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 122.983,
    y1: 269.782,
    x2: 280.311,
    y2: 269.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E3F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 427.854,
    y1: 182.289,
    x2: 428.828,
    y2: 174.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 413.016,
    y1: 166.961,
    x2: 444.94,
    y2: 166.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 424.814,
    y1: 170.44,
    x2: 434.416,
    y2: 152.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 411.59,
    y1: 161.52,
    x2: 446.335,
    y2: 161.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 411.07,
    y1: 155.196,
    x2: 446.883,
    y2: 155.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 428.072,
    y1: 152.462,
    x2: 431.663,
    y2: 135.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 421.312,
    y1: 59.588,
    x2: 492.105,
    y2: 171.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FAB848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FCC345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAB847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F49B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F39252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 408.551,
    y1: 145.835,
    x2: 423.01,
    y2: 103.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 422.186,
    y1: 150.529,
    x2: 436.644,
    y2: 108.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 403.569,
    y1: 144.122,
    x2: 418.055,
    y2: 102.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 423.776,
    y1: 34.346,
    x2: 409.601,
    y2: 150.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FAB848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FCC345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAB847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F49B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F39252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 124.281,
    y1: 179.175,
    x2: 189.442,
    y2: 7.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F4412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#691F0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 423.885,
    y1: 175.218,
    x2: 433.623,
    y2: 157.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 105.523,
    y1: 354.688,
    x2: 39.535,
    y2: 146.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32366D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 304.499,
    y1: 259.823,
    x2: 279.76,
    y2: 92.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32366D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 251.618,
    y1: 267.654,
    x2: 226.852,
    y2: 100.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32366D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 179.433,
    y1: 140.978,
    x2: 182.665,
    y2: 49.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 189.345,
    y1: 75.558,
    x2: 150.279,
    y2: 10.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 162.641,
    y1: 62.458,
    x2: 126.04,
    y2: 127.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED78B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 301.37,
    y1: 222.911,
    x2: 199.592,
    y2: 268.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32366D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 167.235,
    y1: 335.152,
    x2: 101.275,
    y2: 126.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32366D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 152.144,
    y1: 258.65,
    x2: 220.338,
    y2: 207.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32366D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 200.433,
    y1: 134.512,
    x2: 166.012,
    y2: 188.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 452.975,
    y1: 213.045,
    x2: 388.472,
    y2: 187.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 368.4,
    y1: 200.333,
    x2: 362.301,
    y2: 308.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32366D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 150.74,
    y1: 332.124,
    x2: 111.891,
    y2: 218.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32366D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767FE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManIdea);
export default __webpack_public_path__ + "static/media/manIdea.d32af84037ee458b6adc69bc3ab4ec78.svg";
export { ForwardRef as ReactComponent };